import { FormattedMessage } from "react-intl";
import { CustomButton } from "../../../Components/Views/CustomButton/CustomButton";
import { CustomInputText, InputType, InputVariant } from "../../../Components/Views/CustomInputText/CustomInputText";
import { useLoginPageController } from "./LoginPageController";
import "./LoginPage.scss";
import Email from "../../../assets/icons/mail1.svg";
import Password from "../../../assets/icons/password.svg";
import Icon from "../../../assets/icons/md3.svg";
import LoginImage from "../../../assets/loginImage.png";

export interface LoginPageProps {}

const LoginPage = () => {
    const { onSubmit, registerField } = useLoginPageController();

    const loginProps = registerField("email");
    const passwordProps = registerField("password");

    return(
        <div className="LoginPage-Container">
            <div className="LoginPage-root">
                <div className="LoginPage-Header">
                    <div className="LoginPage-welcomeText">
                        <FormattedMessage id="login.text.welcome" />
                    </div>
                    <img src={Icon} alt="Icon" className="LoginPage-Logo"/>
                    <div className="LoginPage-helpText">
                        <FormattedMessage id="login.text.description" />
                    </div>
                </div>
                <div className="LoginPage-actions">
                    <form
                        onSubmit={(event) => {
                            event.preventDefault();
                        }}>
                        <div className="LoginPage-IconsContainer">
                            <img src={Email} alt="Email" className="LoginPage-Icons"/>
                            <CustomInputText
                                {...loginProps}
                                labelIntlId="login.id.placeholder"
                                inputVariant={InputVariant.Standard}
                                classes={{ root: "LoginPage-loginInput" }}
                                placeholderIntlId=""
                            />
                        </div>
                        <div className="LoginPage-IconsContainer">
                            <img src={Password} alt="Password" className="LoginPage-Icons"/>
                            <CustomInputText
                                {...passwordProps}
                                labelIntlId="login.password.placeholder"
                                inputVariant={InputVariant.Standard}
                                classes={{ root: "LoginPage-passwordInput" }}
                                type={InputType.Password}
                                placeholderIntlId=""
                            />
                        </div>
                        <div className="LoginPage-submitButtonContainer">
                        <CustomButton
                            title={<FormattedMessage id="login.button.connect" />}
                            className="LoginPage-submitButton"
                            onClick={onSubmit}
                            type="submit"
                        />
                        </div>
                    </form>
                </div>
            </div>
            <div className="LoginPage-ImageContainer">
            <img src={LoginImage} alt="LoginImage" className="LoginPage-Image"/>
            </div>
        </div>
    );
}

export {LoginPage};